import React from 'react';
import { useIntl } from 'react-intl';
import Top from './Top';
import { Wrapper } from './styled';

interface NavbarProps {
  locale: string;
}

interface NavbarItem {
  key: string;
  text: string;
  link: string;
  openNewTab: boolean;
}

interface NavbarData {
  buttonText: string;
  buttonLink: string;
  loginButton: string;
  logoImage: {
    src: string;
    alt: string;
  };
  animatedLogo: {
    src: string;
  };
  navbarList: NavbarItem[];
}

const Navbar: React.FC<NavbarProps> = ({ locale }) => {
  const navbarList: NavbarItem[] = [
    {
      key: 'news',
      text: 'News',
      link: 'https://news.bitcoin.com/',
      openNewTab: true,
    },
    {
      key: 'wallet',
      text: 'Wallet',
      link: 'https://wallet.bitcoin.com/',
      openNewTab: true,
    },
    {
      key: 'games',
      text: 'Games',
      link: 'https://games.bitcoin.com/',
      openNewTab: true,
    },
    {
      key: 'buy',
      text: 'Buy',
      link: 'https://buy.bitcoin.com/',
      openNewTab: true,
    },
    {
      key: 'learn',
      text: 'Learn',
      link: 'https://www.bitcoin.com/get-started/',
      openNewTab: false,
    },
    {
      key: 'newsletters',
      text: 'Research',
      link: 'https://www.bitcoin.com/newsletters/',
      openNewTab: false,
    },
    {
      key: 'reviews',
      text: 'Reviews',
      link: 'https://www.bitcoin.com/directory/',
      openNewTab: false,
    },
  ];

  const navbarData: NavbarData = {
    buttonText: 'Get Bitcoin',
    buttonLink: 'https://branch.wallet.bitcoin.com/h31z15eNxTb',
    loginButton: 'Login',
    logoImage: {
      src: '/images/uploads/desktop-logo.webp',
      alt: 'Bitcoin.com Logo',
    },
    animatedLogo: {
      src: '/images/uploads/animated-logo.mp4',
    },
    navbarList,
  };

  return (
    <Wrapper>
      <Top top={navbarData} locale={locale} />
    </Wrapper>
  );
};

export default Navbar;
